import { Inject, Pipe, PipeTransform } from '@angular/core';
import { differenceInDays, formatDistance, Locale, parseISO } from 'date-fns';
import { MAT_DATE_LOCALE } from "@angular/material/core";

@Pipe({
    name: 'days_from_now',
    standalone: false
})
export class DaysFromNowPipe implements PipeTransform {

    constructor() {
    }

    transform(end_date: Date): number {
        return differenceInDays(end_date, new Date())
        
    }
}

@Pipe({
    name: 'time_from_now',
    standalone: false
})
export class TimeFromNowPipe implements PipeTransform {
    constructor() {}
    transform(date: string): string {

        return formatDistance(
                  parseISO(date),
                  new Date(),
                  { addSuffix: true }
                );
    }
}

@Pipe({
    name: 'date_time_from_now',
    standalone: false
})
export class DateTimeFromNowPipe implements PipeTransform {
    constructor(
        @Inject(MAT_DATE_LOCALE) private dateLocale: Locale
    ) {}
    transform(date: Date): string {
        return formatDistance(date,
                  new Date(),
                  {
                      addSuffix: true,
                      locale: this.dateLocale
                  }
                );
    }
}

@Pipe({
    name: 'highlight_search',
    standalone: false
})
export class HighlightSearchPipe implements PipeTransform {
  transform(value: string, args: string): string {
    if (!args) {
      return value;
    }

    const regex = new RegExp(args, 'gi');
    const match = value.match(regex);

    if (!match) {
      return value;
    }

    return value.replace(regex, `<span class='highlight'>${match[0]}</span>`);
  }
}

@Pipe({
    name: 'backoffice_search',
    standalone: false
})
export class BackofficeSearchPipe implements PipeTransform {
  transform(value: string): string {

      function checkPattern(text: string, pattern: RegExp) {
          const regex = new RegExp(pattern, 'gi');
          const match = text.match(regex);
          if (!match) {
              return text;
          } else {
              return text.replace(regex, `<a href="#/admin/search?query=${match[0]}">${match[0]}</a>`);
          }
      }

      const emailPattern = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/
      const uuidPattern = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/

      return checkPattern(checkPattern(value, uuidPattern), emailPattern);
  }
}